module.exports = __webpack_public_path__ + "static/media/ciprian_alupului.e46dcff3.png";